import { render, staticRenderFns } from "./QueueActivity.vue?vue&type=template&id=344ed6a8&scoped=true&"
import script from "./QueueActivity.vue?vue&type=script&lang=js&"
export * from "./QueueActivity.vue?vue&type=script&lang=js&"
import style0 from "./QueueActivity.vue?vue&type=style&index=0&id=344ed6a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ed6a8",
  null
  
)

export default component.exports